module.exports = __webpack_public_path__ + "static/media/example1.f6b360c1.jpg";